import React from 'react'
import "./SplashScreen.css"
import BrandLogo from '../../Components/BrandLogo/BrandLogo';
import { version } from "../../version"

export default function SplashScreen() {
  return (
    <div className='splashScreen bgContainer'>
        <div className='blurOverlay splashWrapper'>
        <BrandLogo />
        <p className='version'>نسخه {version}</p>
        </div>
    </div>
  )
}
